import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { personnel, PersonnelSignsManipulationViewModel } from "./personnelSignsManipulation-viewModel"

export class PersonnelSignsManipulationView extends View<PersonnelSignsManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-B9EB7D20-8E6B-489B-89D2-35164F9841FA"
    }
    loadHtml(): string {
        let element = require('./personnelSignsManipulation.html').default;
        let style = require('./personnelSignsManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set personnel(v: ObservableArray<personnel>) { this._personnel = v; } public get personnel(): ObservableArray<personnel> { return this._personnel;} private _personnel: ObservableArray<personnel>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
}
